module.exports = __webpack_public_path__ + "img/playSmall.cefe9a3e.svg";